import { __extends } from "tslib";
import { URLRequest as URLRequestAway, URLVariables as URLVariablesAway } from '@awayjs/core';
import { ASObject, axCoerceString, transformJSValueToAS, transformASValueToJS } from '@awayfl/avm2';
import { URLVariables } from './URLVariables';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: URLRequest
var URLRequest = /** @class */ (function (_super) {
    __extends(URLRequest, _super);
    function URLRequest(url) {
        if (url === void 0) { url = null; }
        var _this = _super.call(this) || this;
        _this._adaptee = new URLRequestAway(url);
        return _this;
    }
    Object.defineProperty(URLRequest.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        set: function (value) {
            this._adaptee = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLRequest.prototype, "url", {
        get: function () {
            return this._adaptee.url;
        },
        set: function (value) {
            value = axCoerceString(value);
            this._adaptee.url = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLRequest.prototype, "data", {
        get: function () {
            var adapteeData = this._adaptee.data;
            var returnData = this._adaptee.data;
            if (adapteeData instanceof URLVariablesAway) {
                returnData = new URLVariables();
                for (var key in this._adaptee.data.variables) {
                    returnData['$Bg' + key] = this._adaptee.data.variables[key];
                }
            }
            else if (typeof adapteeData === 'object') {
                returnData = transformJSValueToAS(this.sec, adapteeData, true);
            }
            return returnData;
        },
        set: function (value) {
            var jsValue;
            if (this.sec.flash.net.URLVariables.axIsType(value)) {
                jsValue = new URLVariablesAway();
                for (var key in value) {
                    if (key.indexOf('$Bg') == 0 && !(typeof value[key] === 'function')) {
                        jsValue.variables[key.replace('$Bg', '')] = value[key];
                    }
                }
            }
            else {
                jsValue = transformASValueToJS(this.sec, value, true);
            }
            this._adaptee.data = jsValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLRequest.prototype, "method", {
        get: function () {
            return this._adaptee.method;
        },
        set: function (value) {
            this._adaptee.method = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLRequest.prototype, "contentType", {
        get: function () {
            console.log('TODO: URLRequest.contentType');
            return ''; //this._adaptee.contentType;
        },
        set: function (value) {
            console.log('TODO: URLRequest.contentType');
            //this._adaptee.contentType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLRequest.prototype, "requestHeaders", {
        get: function () {
            console.log('TODO: URLRequest.requestHeaders');
            return null; //this._adaptee.contentType;
        },
        set: function (value) {
            console.log('TODO: URLRequest.requestHeaders');
            //this._adaptee.contentType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(URLRequest.prototype, "digest", {
        get: function () {
            console.log('TODO: URLRequest.digest');
            return null; //this._adaptee.contentType;
        },
        set: function (value) {
            console.log('TODO: URLRequest.digest');
            //this._adaptee.contentType = value;
        },
        enumerable: true,
        configurable: true
    });
    return URLRequest;
}(ASObject));
export { URLRequest };
